// MIDDLEWARES
import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import logger from 'redux-logger'
import createSagaMiddleware from 'redux-saga'

import adminSlice from './features/adminSlice'
import agenciesSlice from './features/agenciesSlice'
import authSlice from './features/authSlice'
import caseworkSlice from './features/caseworkSlice'
import constituentsSlice from './features/constituentsSlice'
import contactMethodsSlice from './features/contactMethodsSlice'
import directorySlice from './features/directorySlice'
import { errorSlice } from './features/errorSlice'
import groupsSlice from './features/groupsSlice'
import homeSlice from './features/homeSlice'
import profileSlice from './features/profileSlice'
import reportSlice from './features/reportSlice'
import staffSlice from './features/staffSlice'
import toolsSlice from './features/toolsSlice'
import topicsSlice from './features/topicsSlice'
import { caseworkAPI, profileAPI } from './rtkq'
import rootSaga from './sagas'

const sagaMiddleware = createSagaMiddleware()

const middleware = [
  sagaMiddleware,
  caseworkAPI.middleware,
  profileAPI.middleware,
]

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger)
}

export const store = configureStore({
  reducer: {
    [caseworkAPI.reducerPath]: caseworkAPI.reducer,
    [profileAPI.reducerPath]: profileAPI.reducer,
    admin: adminSlice,
    auth: authSlice,
    casework: caseworkSlice,
    constituents: constituentsSlice,
    groups: groupsSlice,
    staff: staffSlice,
    directory: directorySlice,
    profile: profileSlice,
    tools: toolsSlice,
    topics: topicsSlice,
    home: homeSlice,
    agencies: agenciesSlice,
    reports: reportSlice,
    error: errorSlice,
    contactmethods: contactMethodsSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: [
          'payload.navigate',
          'payload.callback',
          'payload.callbackSuccess',
          'payload.callbackFailure',
          'payload.values', // Ignore File objects
        ],
      },
    }).concat(middleware),
  devTools: process.env.NODE_ENV !== 'production',
})

sagaMiddleware.run(rootSaga)
setupListeners(store.dispatch)
